import {
  Component,
  ElementRef,
  Optional,
  Self,
} from '@angular/core';
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormField, MatLabel, MatSuffix, MatError, MatHint } from '@angular/material/form-field';
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import {MatBaseInputComponent} from '../mat-base-input.component';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { MtxDatetimepickerMode, MtxDatetimepickerType, MtxDatetimepickerInput, MtxDatetimepickerToggle, MtxDatetimepicker } from '@ng-matero/extensions/datetimepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMatDateAdapter } from '@ngxmc/datetime-picker';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { NgClass, NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-mat-time-input',
    providers: [
        { provide: MatFormFieldControl, useExisting: MatTimeInputComponent },
        { provide: NgxMatDateAdapter, useExisting: MatMomentDateModule },
        { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
        {
            provide: MTX_DATETIME_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'hh:mm a',
                    monthInput: 'MMMM',
                    timeInput: 'hh:mm a',
                    datetimeInput: 'hh:mm a',
                },
                display: {
                    dateInput: 'hh:mm a',
                    monthInput: 'MMMM',
                    timeInput: 'hh:mm a',
                    datetimeInput: 'hh:mm a',
                    monthYearLabel: 'YYYY MMMM',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                    popupHeaderDateLabel: 'MMM DD, ddd',
                },
            },
        },
    ],
    template: `
    <mat-form-field class="regular-form-field" [ngClass]="{'inline': inlineLabel, 'no-label': inlineLabel}"
                    [hintLabel]="hintLabel"
                    [appearance]="appearance"
                    (focusin)="onFocusIn($event)"
                    (focusout)="onFocusOut($event)">
      <mat-label>
        {{label}}
      </mat-label>
      <input matInput
             [mtxDatetimepicker]="datetimePicker"
             (keyup)="onKeyUp($event)"
             [formControl]="formControl"
             type="text"
             [id]="_id"
             [name]="name"
             [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
             [autocomplete]="autocomplete"
      >
      <mtx-datetimepicker-toggle [for]="datetimePicker" matSuffix></mtx-datetimepicker-toggle>
      <mtx-datetimepicker #datetimePicker
                          [type]="type"
                          [mode]="mode"
                          [multiYearSelector]="false"
                          startView="clock"
                          [twelvehour]="true"
                          [timeInterval]="1"
                          [touchUi]="false"></mtx-datetimepicker>
      <mat-icon matSuffix class="explanation" *ngIf="!!explanation" matTooltip="{{explanation}}">info_outline</mat-icon>
      <mat-error *ngIf="formControl.invalid">{{firstError()}}</mat-error>
      <mat-hint align="start" *ngIf="!formControl.invalid">{{infoText}}</mat-hint>
    </mat-form-field>
  `,
    styles: [
        '.label-text {vertical-align: middle;}'
    ],
    standalone: true,
    imports: [MatFormField, MatFormFieldFix, NgClass, MatLabel, MatInput, MtxDatetimepickerInput, FormsModule, ReactiveFormsModule, MtxDatetimepickerToggle, MatSuffix, MtxDatetimepicker, NgIf, MatIcon, MatTooltip, MatError, MatHint]
})
export class MatTimeInputComponent extends MatBaseInputComponent {

  type: MtxDatetimepickerType = 'time';
  mode: MtxDatetimepickerMode = 'auto';

  constructor(@Optional() @Self() public ngControl: NgControl, public _elementRef: ElementRef<HTMLElement>) {
    super(ngControl, _elementRef);
  }
}
